export default __webpack_public_path__ + "static/media/Logo_GIF.ee17da22.gif";